<script setup lang="ts">
import type { NavigationLinkFragment } from '#graphql-operations'

interface ButtonNavProps {
  title?: string
  link?: NavigationLinkFragment
}

const props = defineProps<ButtonNavProps>()
const buttonLabel = computed(() => props.title || props.link?.title)
</script>

<template>
  <CraftLink
    :link
    as="button"
    :aria-label="buttonLabel"
    class="buttonNavSubmenu motion-snug inline-flex gap-2 cursor-pointer items-center @hover:c-$accent-color focus-within:c-$accent-color"
  >
    <slot>
      <Text
        v-if="buttonLabel"
        :text="buttonLabel"
        class="text typo-serif-1"
      />
    </slot>
    <slot name="icon" />
  </CraftLink>
</template>

<style scoped>
.buttonNavSubmenu {
  position: relative;
}

.buttonNavSubmenu.router-link-exact-active {
  color: var(--accent-color);
}

.buttonNavSubmenu :deep(.icon) {
  position: absolute;
  left: 100%;
  margin-left: calc(var(--spacing) * 2);
}
</style>
